module.exports = __webpack_public_path__ + "static/kayak-school-f684dc3f14fc549c09c646de7c59eb3e.jpg";